export default "__VITE_ASSET__7859c95b__"